import useSWR from "swr";

export default function useMarketplaceDetails(){
    const { data, error } = useSWR('marketplaces/details');
    const isLoading = !error && !data;
    
    return {data, isLoading, error};
};